'use strict';

module.exports = {
    'gFp@DiTt@@B !Bg~wK_}mvw@`': { '0-1': 8, '0-2': 8, '1-3': 8, '3-5': 8, '4-5': 8, '2-4': 8, '0-3': 2.5, '0-4': 2.5, '3-4': 2.5, '1-2': 2.5, '1-5': 2.5, '2-5': 2.5, '2-3': 1, '1-4': 1, '0-5': 1 },
    'gKQ@@eKcRpD !BcLbLypAe@Bh': { '1-3': 1.8, '2-4': 1.8, '1-4': 0.5, '2-3': 0.5, '1-2': 1.55, '3-4': 3.5 },
    'gKX@@eKcRpD !BcLbLipBe@Lh': { '1-3': 2.2, '2-4': 2.2, '1-4': 1.25, '2-3': 1.25, '1-2': 2.05, '3-4': 3.4 },
    'gKPH@DIRxtlA@ !BcLbLqp@e@Dh': { '1-3': 5.2, '2-4': 5.2, '1-4': 1.25, '2-3': 1.25, '1-2': 2.7, '3-4': 3.6 },
    'gFx@@eJf`@@P !BbOsWGx@_`CW@': { '1-3': 5.3, '2-4': 5.3, '1-4': 0.9, '2-3': 0.9, '1-2': 0.35, '3-4': 1.65, '1-5': 1.8, '2-5': 1.8, '3-5': 7.85, '4-5': 7.85 },
    'gKT@Adi\\Vf@` !Bo`@oIR}jXq`': { '2-4': 1.5, '1-4': 1.5, '1-2': 0.75 },
    'gKT@ADi\\Yi@` !BKrk~_qLgKtT': { '2-4': 1.5, '3-4': 2.5, '2-3': 0.75 },
    'gKY@LDi\\ZV@` !BXNTSIwysA\\\\': { '1-2': 0.5, '2-4': 0.8 },
    'gKXHL@aJWFe`H !BXNTSIwysA\\\\': { '1-2': 1.9, '2-4': 3.2 },
    'gKXHL@aJWFe`H !BHFTSI{ycA\\\\': { '2-4': 4.7, '3-4': 1.7 },
    'gFxA@IReSP@@H !BlCvwO[yog~wOP': { '1-3': 6, '2-4': 6, '2-5': 1.5, '1-5': 2.5, '2-3': 0.8, '1-4': 0.8, '1-2': 1, '3-5': 8, '4-5': 8, '3-4': 1.4 },
    'gFt@ADiTt@@B !Bmsr~_{_}mv~_p': { '2-4': 4.9, '3-5': 4.9, '2-5': 2, '3-4': 2, '2-3': 3.5, '4-5': 8.4 },
    'gFt@AdiTt@@B !Bo`BWoY_|epJWoP': { '4-5': 5, '2-5': 2.5, '1-5': 1.5, '1-4': 0 },
    'gFt@ATiTt@@B !Br@KgCx@O`Cg@': { '1-3': 1.8, '2-4': 1.8, '1-4': 1.8, '2-3': 1.8, '1-2': 0.5, '3-4': 0.5 }
};


// WEBPACK FOOTER //
// ./lib/extend/fragments.js